module.exports = __webpack_public_path__ + "img/empty_state_learning.66a74760.svg";